import Button from 'components/form/Button';
import BackButton from 'components/layouts/BackButton';
import { NumberDisplay } from 'components/layouts/Display';
import React from 'react';
import { Link } from 'react-router-dom';
import useAccountStore from 'state/accountStore';

const Wallet = () => {
  window.document.title = 'Wallet';
  const { account } = useAccountStore();
  return (
    <section className="py-5">
      <BackButton text="wallet" />
      <br />
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-11">
        <div className="col-span-5 rounded-xl border border-green-500 bg-green-400 py-8 px-10 md:col-span-2 lg:col-span-5">
          <div className="flex items-end justify-between">
            <div>
              <p className="font-semibold text-gray-700">Investment</p>
              <br />
              <p className="text-[23px] font-bold">
                <NumberDisplay value={account?.investment ?? 0} />
              </p>
            </div>
            <Link to="/dashboard/invest">
              <p className="rounded-md bg-brand-dark px-3 py-2 text-white">
                invest now
              </p>
            </Link>
          </div>
        </div>
        <div className="col-span-5 rounded-xl border border-blue-400 bg-blue-500 py-8 px-10 text-white  md:col-span-3">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-semibold text-gray-700">Balance</p>
              <br />
              <p className="font-bold">
                <NumberDisplay value={account?.balance ?? 0} />
              </p>
            </div>
            <Link to="/dashboard/withdraw">
              <p className="rounded-md border border-slate-300 px-3 py-2 hover:bg-white hover:text-black">
                withdraw
              </p>
            </Link>
          </div>
        </div>
        <div className="col-span-5 rounded-xl border border-slate-300 bg-slate-200 py-8 px-10 lg:col-span-3">
          <p className="font-semibold text-gray-700">Profit</p>
          <p className="font-bold">
            <NumberDisplay value={account?.profit ?? 0} />
          </p>
        </div>
      </div>
      <br />
      <div className="grid grid-cols-1 gap-4 lg:grid-flow-col lg:grid-cols-none lg:grid-rows-3">
        <div className="lg:col-span-none col-span-5 rounded-xl border bg-white p-5 lg:row-span-3">
          <img
            src="/assets/icons/bitcoin_one.svg"
            alt="btc_logo"
            className="h-[140px] w-[140px]"
          />
          <br />
          <p className="my-3 text-[20px] font-bold">Bitcoin</p>
          <p className="font-bold">
            {<NumberDisplay value={account?.bitcoin ?? 0} />}
          </p>
        </div>
        <div className="col-span-5 rounded-xl border p-5">
          <div className="flex items-center gap-x-5">
            <img
              src="/assets/icons/usdt.svg"
              alt="btc_logo"
              className="h-[40px] w-[40px]"
            />
            <p>
              <span className="font-bold">Tether</span> -{' '}
              <span>{<NumberDisplay value={account?.usdt ?? 0} />}</span>{' '}
            </p>
          </div>
        </div>
        <div className="col-span-5 row-span-2 rounded-xl border p-5">
          <div className="flex items-end justify-between">
            <div>
              <img
                src="/assets/icons/ethereum.svg"
                alt="btc_logo"
                className="h-[60px] w-[60px]"
              />
              <br />
              <p className="my-3 text-[20px] font-bold">Ethereum</p>
              <p className="font-bold">
                <span>{<NumberDisplay value={account?.ethereum ?? 0} />}</span>{' '}
              </p>
            </div>
            <Button className="rounded-md bg-blue-500 px-3 py-2 text-white">
              purchase more
            </Button>
          </div>
        </div>
      </div>
      <br />
      <div className="mt-10 flex flex-col gap-3 rounded-xl border lg:h-[150px] lg:flex-row">
        <div className="basis-1/5  px-3 py-8 lg:border-r">
          <p className="my-3 text-[20px] font-bold">Litecoin</p>
          <p className="font-bold">$0</p>
        </div>
        <div className="basis-1/5 border-t px-3 py-8 lg:border-r lg:border-t-0">
          <p className="my-3 text-[20px] font-bold">BNB</p>
          <p className="font-bold">$0</p>
        </div>
        <div className="basis-1/5 border-t px-3 py-8 lg:border-r lg:border-t-0">
          <p className="my-3 text-[20px] font-bold">BCH</p>
          <p className="font-bold">$0</p>
        </div>
        <div className="basis-1/5 border-t px-3 py-8 lg:border-r lg:border-t-0">
          <p className="my-3 text-[20px] font-bold">ADA</p>
          <p className="font-bold">$0</p>
        </div>
        <div className="basis-1/5 border-t px-3 py-8 lg:border-t-0">
          <p className="my-3 text-[20px] font-bold">XRP</p>
          <p className="font-bold">$0</p>
        </div>
      </div>
    </section>
  );
};

export default Wallet;
